import { daysOfTheWeekP, generalHelpers, months } from '@monorepo/helpers';
import { FC } from 'react';
import { typeCartPeriod } from '@monorepo/models';
import { useGetCurrentUser } from '@/custom-hooks';
import { useNavigate } from 'react-router';

type propsType = {
};

export const UserAssignmentsCarts: FC<propsType> = ({ }) => {
    const navigate = useNavigate();
    const user = useGetCurrentUser();

    return (
        <div className={'my-2'}>
            <h3>
                Asignaciones de Carritos/Exhibidores:
            </h3>
            {!!user.cartAssignments?.filter(a => new Date(a.year, a.month) >= new Date(new Date().getFullYear(), new Date().getMonth())).length ?
                (user.cartAssignments
                    .filter(a => new Date(a.year, a.month) >= new Date(new Date().getFullYear(), new Date().getMonth()))
                    .map(a =>
                        <button key={a.id}
                            className={'btn btn-success text-start w-100 mt-3'}
                            style={{ fontWeight: 'bolder' }}
                            onClick={() => navigate(`/tablero`)}
                        >
                            {daysOfTheWeekP[a.weekday]} de {months[a.month]} {a.year} {generalHelpers.GetTimeFromPeriodObject(a as typeCartPeriod)} con {a.participants?.find(x => x.userId !== user.id)?.name} {a.participants?.find(x => x.userId !== user.id)?.lastName} - {a.name}
                        </button>
                    )
                )
                :
                <h4>
                    Ninguna
                </h4>
            }
        </div>
    );
}
